"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = matchDetailed;

function matchDetailed(input, regex) {
  var match;
  var matches = [];

  while (match = regex.exec(input)) {
    matches.push(match);
  }

  return matches;
}